import { DataQaGroup } from '../dataQaContract';
import { isReadyAtFinest } from './data-qa-utils';

/**
 * Where a group lands in the summary partition. Every group gets exactly one,
 * so the four counts always sum to the number of groups analyzed.
 */
export type PathClass = 'finest' | 'rollup' | 'scalingOnly' | 'none';

/** Scaling is viable at some grain. Overlaps every forecast class except `none`. */
export const isScalingReady = (g: DataQaGroup): boolean =>
  g.path.scaling.recommended_grain !== 'none';

// Single source of truth for the summary tiles and the matching Show filters,
// so a tile's count and the rows it filters to can never drift. First match
// wins: a group's best forecast path decides first, and scaling only breaks
// the tie once forecast is blocked at every rung.
export const classifyPath = (g: DataQaGroup): PathClass => {
  if (isReadyAtFinest(g.path.forecast)) {
    return 'finest';
  }
  if (g.path.forecast.recommended_grain !== 'none') {
    return 'rollup';
  }
  if (isScalingReady(g)) {
    return 'scalingOnly';
  }
  return 'none';
};

export const countPathClasses = (groups: DataQaGroup[]): Record<PathClass, number> => {
  const counts: Record<PathClass, number> = { finest: 0, rollup: 0, scalingOnly: 0, none: 0 };
  groups.forEach(g => {
    counts[classifyPath(g)] += 1;
  });
  return counts;
};
